import React, { Component } from 'react';
import { UserIcon, MapPinIcon, CreditCardIcon, WalletIcon, SettingsIcon, HelpCircleIcon, LogOutIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { BottomNav } from '../components/BottomNav';
import { useApp } from '../context/AppContext';
export const Profile: React.FC = () => {
  const navigate = useNavigate();
  const {
    user
  } = useApp();
  const menuItems = [{
    icon: MapPinIcon,
    label: 'Saved Places',
    action: () => navigate('/saved-places')
  }, {
    icon: CreditCardIcon,
    label: 'Payment Methods',
    action: () => navigate('/payment-methods')
  }, {
    icon: WalletIcon,
    label: 'My Wallet',
    action: () => navigate('/wallet')
  }, {
    icon: SettingsIcon,
    label: 'Settings',
    action: () => navigate('/settings')
  }, {
    icon: HelpCircleIcon,
    label: 'Help & Support',
    action: () => navigate('/help')
  }, {
    icon: LogOutIcon,
    label: 'Logout',
    action: () => navigate('/login'),
    danger: true
  }];
  return <div className="min-h-screen bg-background pb-16" data-id="element-449">
      <div className="p-6" data-id="element-450">
        <h1 className="text-xl font-semibold mb-6" data-id="element-451">My Profile</h1>
        <div className="card mb-8" data-id="element-452">
          <div className="flex items-center" data-id="element-453">
            <div className="w-16 h-16 bg-primary bg-opacity-20 rounded-full flex items-center justify-center mr-4" data-id="element-454">
              <UserIcon size={32} className="text-primary" data-id="element-455" />
            </div>
            <div data-id="element-456">
              <h2 className="text-lg font-semibold" data-id="element-457">{user.name}</h2>
              <p className="text-white text-opacity-70" data-id="element-458">{user.phone}</p>
              <button className="text-primary text-sm mt-1" data-id="element-459">
                Edit Profile
              </button>
            </div>
          </div>
        </div>
        <div className="space-y-3" data-id="element-460">
          {menuItems.map((item, index) => {
          const IconComponent = item.icon;
          return <div key={index} className="card flex items-center justify-between" onClick={item.action} data-id="element-461">
                <div className="flex items-center" data-id="element-462">
                  <IconComponent size={20} className={item.danger ? 'text-red-500' : 'text-primary'} data-id="element-463" />
                  <span className={`ml-3 ${item.danger ? 'text-red-500' : ''}`} data-id="element-464">
                    {item.label}
                  </span>
                </div>
                <ChevronRightIcon size={20} className={item.danger ? 'text-red-500' : 'text-primary'} data-id="element-465" />
              </div>;
        })}
        </div>
      </div>
      <BottomNav data-id="element-466" />
    </div>;
};